import React, { useState, useEffect } from "react";
import { Table, Button, Pagination, message } from "antd";
import ExpertQADetail from "../pages/ExpertQADetail";
import { binaryContentsHooks as cHooks } from "../hooks";

const ExpertQALayout = () => {
  const [qas, setQAs] = useState([]); // 질문 리스트
  const [loading, setLoading] = useState(false); // 로딩 상태
  const [page, setPage] = useState(1); // 현재 페이지
  const [total, setTotal] = useState(0); // 전체 데이터 개수
  const [selectedQA, setSelectedQA] = useState(null); // 선택된 QA
  const [isDetailModalVisible, setIsDetailModalVisible] = useState(false); // 상세 모달 상태

  // QA 리스트 가져오기
  const fetchQAs = async (currentPage = 1) => {
    setLoading(true);
    try {
      const response = await cHooks.expertQAList({ page: currentPage });
      const { data, cnt } = response.data;

      setQAs(data);
      setTotal(cnt);
    } catch (error) {
      console.error("QA 데이터를 가져오는 중 오류가 발생했습니다.", error);
      message.error("QA 데이터를 불러오는 중 오류가 발생했습니다.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQAs(page);
  }, [page]);

  // 테이블 컬럼 정의
  const columns = [
    { title: "작성자", dataIndex: "user_name" },
    { title: "제목", dataIndex: "qa_title" },
    {
      title: "응답 상태",
      dataIndex: "reply_status",
      render: (replyStatus) => (replyStatus ? "응답 완료" : "미응답"),
    },
    {
      title: "공개 여부",
      dataIndex: "is_private",
      render: (isPrivate) => (isPrivate ? "비공개" : "공개"),
    },
    { title: "생성일자", dataIndex: "created_at" },
    { title: "수정일자", dataIndex: "updated_at" },
    {
      title: "상세보기",
      render: (record) => (
        <Button
          type="link"
          onClick={() => {
            setSelectedQA(record);
            setIsDetailModalVisible(true);
          }}
        >
          상세 보기
        </Button>
      ),
    },
  ];

  return (
    <div>
      <h2 style={{ marginBottom: "20px" }}>전문가 QA 관리</h2>
      <Table
        columns={columns}
        dataSource={qas}
        rowKey="id"
        loading={loading}
        pagination={false}
      />
      <Pagination
        current={page}
        total={total}
        pageSize={10}
        onChange={(newPage) => setPage(newPage)}
        style={{ marginTop: 20, textAlign: "center" }}
      />
      {isDetailModalVisible && selectedQA && (
        <ExpertQADetail
          visible={isDetailModalVisible}
          onClose={() => setIsDetailModalVisible(false)}
          qa={selectedQA}
        />
      )}
    </div>
  );
};

export default ExpertQALayout;
